// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "GetCoupon/js/" + (chunkId === 885 ? "site_app_entry" : chunkId) + "." + {"148":"e6abca41","885":"b9d59a11"}[chunkId] + ".js";
};